/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pages: NonNullable<unknown> }} Terms_Plans_2Inputs */

const da_terms_plans_2 = /** @type {(inputs: Terms_Plans_2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 credit retter 1 besvarelse. Besvarelser på mere end ${i?.pages} sider tæller som 2. Hvis en rettelse mislykkes, bruges der ingen credits. Credits fra et abonnement udløber på den dato, der står under Abonnement. Ekstra besvarelser udløber ikke.`)
};

/** @type {(inputs: Terms_Plans_2Inputs) => LocalizedString} */
const en_terms_plans_2 = da_terms_plans_2;

/**

* @param {Terms_Plans_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_plans_2 = /** @type {((inputs: Terms_Plans_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Plans_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_plans_2(inputs)
	return da_terms_plans_2(inputs)
});